export const SubjTypes = [
    [ 'intro', 'C_INTRO' ],
    [ 'culture', 'C_CULTURE' ],
    [ 'history', 'History' ],
    [ 'architect', 'Architecture' ],
    [ 'religion', 'Religion' ],
    [ 'warfare', 'C_WARFARE' ],
    [ 'industry', 'C_INDUSTRY' ],
    [ 'science', 'Science' ],
    [ 'technique', 'Technique' ],
    [ 'craft', 'Craft' ],
    [ 'nature', 'C_NATURE' ],
    [ 'rural', 'Landfill' ],
    [ 'sport', 'C_SPORT' ],
    [ 'health', 'C_HEALTH' ],
    [ 'transport', 'C_TRANSPORT' ],
    [ 'children', 'C_CHILDREN' ],
    [ 'person', 'C_PERSON' ],
    [ 'tasting', 'C_TASTING' ],
    [ 'masterc', 'C_MASTER' ],
    [ 'hunting', 'C_HUNT' ],
    [ 'fishing', 'C_FISH' ],
    [ 'swimming', 'C_SWIM' ],
    [ 'diving', 'C_DIVE' ],
    [ 'climbing', 'C_CLIMB' ],
    [ 'ethnicity', 'C_ETHNIC' ],
    [ 'quest', 'C_QUEST' ]
]
